import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'

import React from "react";
import { GetCount } from "../ShoppingCart/CartHandler.js";
import "./Header.css";
import CategoryNavigation from "../CategoryNavigation/CategoryNavigation.js";
import CategorySearchResults from "../CategoryResults/CategorySearchResults.js";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ClearIcon from '@mui/icons-material/Clear';
import {
    ShoppingBagIcon,
    MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import "./MobileHeader.css"
import { Box, Grid, TextField } from '@mui/material';


const navigation = [
    { name: 'Home', href: '/', current: true },
    { name: 'Contact', href: '#', current: false },
    { name: 'Help', href: '#', current: false },
    { name: 'Chat', href: '#', current: false },
]
const apiUrl = process.env.REACT_APP_BASEURL;

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Navigation({
    token,
    setSearch,
    category,
    setCategory,
    page,
    setPage,
    categories,
    setCategories,
    cartCount,
    setCartCount,
    productData
}) {

    const [canAdmin, setCanAdmin] = useState(false);
    const [count, setCount] = useState(GetCount());
    const [firstName, setFirstName] = useState("TempFirstName");
    const [searchText, setSearchText] = useState('');
    const [filter, setFilter] = useState(productData)
    const [header, setHeader] = useState("Awaiting Header");
    const [headerFixed, setHeaderFixed] = useState(false)
    const [headerOption, setHeaderOption] = useState("Category Header");
    const [logo, setLogo] = useState();
    const [logoSize, setLogoSize] = useState(5);
    const [myHeader, setMyHeader] = useState(header);
    const navigate = useNavigate();
    const [ribbonText, setRibbonText] = useState("CenterPrism is Awesome");
    const [mobSearch, setMobSearch] = useState({
        mobileSearch: "none"
    })

    let mobileSearch = document.getElementsByClassName("m-search")


    const getCategories = () => {
        axios
            .get(apiUrl + "/api/Items/GetCategories")
            .then((response) => {
                // console.log("getCategories response data line 30:", response.data);
                if (Array.isArray(response.data)) {
                    setCategories(response.data); // Make sure response.data is an array
                } else {
                    setCategories([response.data]);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getHeader = () => {
        axios
            .get(apiUrl + `/api/Header/GetRibbon`, {})
            .then((response) => {
                setHeader(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getHeaderSyle = () => {
        // axios call goes here when header syle is built out in desktop
        // REMEMBER TO ADD TO useEffect
    };

    const getLogo = () => {
        axios
            .get(apiUrl + `/api/Header/GetLogo`, {})
            .then((response) => {
                const thisLogo = response.data;
                setLogo(thisLogo.image);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getLogoSize = () => {
        axios
            .get(apiUrl + `/api/Header/GetLogoSize`, {})
            .then((response) => {
                setLogoSize(response.data);
            })
            .catch((error) => {
                // console.log("get logo size error: " + error);
            });
    };

    const getRibbon = () => {
        axios
            .get(apiUrl + `/api/Header/GetRibbon`, {})
            .then((response) => {
                setRibbon(response.data); // Make sure response.data is an array
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const GetSearchResults = () => {
        setSearch(searchText);
        navigate("/ItemSearchResults");
    };

    const GetCategoryResults = (catInst) => {
        setCategory(catInst);
        navigate("/CategorySearchResults");
    };

    const GetPortal = () => {
        navigate("/Portal");
    };

    const GetCart = () => {
        navigate("/myCart");
    };

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    const resetSearchInput = () => {
        setSearchText('');
        navigate("/")
    }

    const handleLogoClick = () => {
        navigate("/");
        resetCategory();
    };


    // const headerStyle = () => ({
    //     background: `rgb(${ribbon.backgroundR}, ${ribbon.backgroundG}, ${ribbon.backgroundB})`,
    //     color: `rgb(${ribbon.textColorR},${ribbon.textColorG},${ribbon.textColorB})`,
    //     height: logoSize.logoMaxHeight + 5,
    //     marginBottom: 5
    // });


    const logoStyle = () => ({
        maxHeight: logoSize.logoMaxHeight,
    });

    const positiveCount = () => {
        return GetCount() === 0 ? false : true;
    };

    const resetCategory = () => {
        setCategory(null);
    };

    const generateButtons = () => {
        if (categories.length !== 0) {
            return categories.map((catInst) => {
                return (
                    <button
                        key={catInst.name}
                        className="cat-button"
                        onClick={() => GetCategoryResults(catInst)}
                    >
                        {catInst.name}
                    </button>
                );
            });
        }
        return null;
    };

    const [ribbon, setRibbon] = useState({
        backgroundB: 0,
        backgroundG: 0,
        backgroundR: 0,
        id: 1,
        lineHeight: 0.5,
        loginText: "Default Login Text",
        logoLeftOfRibbon: true,
        logoSize: 10,
        logoTopRightOnLogin: false,
        logoUnderMenu: false,
        numberOfNewItems: 25,
        numberOfPopularItems: 25,
        ribbonText: "Default Ribbon Text",
        size: 3,
        textColorB: 255,
        textColorG: 255,
        textColorR: 255,
    });

    const ribbonStyle = () => ({
        background: `rgb(${ribbon.backgroundR}, ${ribbon.backgroundG}, ${ribbon.backgroundB})`,
        color: `rgb(${ribbon.textColorR},${ribbon.textColorG},${ribbon.textColorB})`,
    });

    // const [subCategories, setSubCategories] = useState([]);
    const updateCanAdmin = () => {
        if (!token) {
            setCanAdmin(false);
        } else {
            setCanAdmin(token.canAdmin);
        }
    };
    const updateFirstName = () => {
        if (!token) {
            setFirstName("Valued Customer");
        } else {
            setFirstName(token.firstName);
        }
    };

    useEffect(() => {
        getLogo();
        getLogoSize();
        getRibbon();
        getHeader();
        getCategories();
    }, []);

    useEffect(() => {
        updateCanAdmin();
        updateFirstName();
    }, [token]);

    useEffect(() => {
        setRibbonText(ribbon.ribbonText);
        ribbonStyle();
    }, [ribbon]);

    useEffect(() => {
        setCount(GetCount());
    }, [category, categories, navigate]);


    const returnHeaderStyle = () => {
        if (headerOption === "Category Header") {
            return (
                <div
                    className="flex-row category-scroller"
                    style={{ overflowX: "scroll" }}

                >
                    {/* <button onClick={() => handleScroll(-100)}></button>  */}
                    {generateButtons()}
                    {/* <button onClick={() => handleScroll(100)}></button> */}
                </div>
            );
        } else {
            <div className="flex-row full-width">
                <CategoryNavigation
                    className="full-width"
                    token={token}
                    category={category}
                    setCategory={setCategory}
                    categories={categories}
                    setCategories={setCategories}
                    page={page}
                    setPage={setPage}
                />
            </div>;
        }
    };

    window.addEventListener("scroll", () => {
        if (window.scrollY > 200) {
            setHeaderFixed(true);
        } else {
            setHeaderFixed(false)
        }


    })



    return (
        <Box>
            <Disclosure as="nav" className="bg-gray-800 ">
                {({ open }) => (
                    <>
                        <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 ">
                            <div className="relative flex h-16 items-center justify-between">
                                <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                    {/* Mobile menu button*/}
                                    <DisclosureButton className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                        <span className="absolute -inset-0.5" />
                                        <span className="sr-only">Open main menu</span>
                                        {open ? (
                                            <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                                        ) : (
                                            <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                                        )}
                                    </DisclosureButton>
                                </div>
                                <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                                    <div className="lg:flex lg:flex-shrink-0 lg:items-center">
                                        <img
                                            className="header-image"
                                            onClick={handleLogoClick}
                                            src={"data:image/png;base64, " + logo}
                                            id="logoImg"
                                            alt="WaitingForLogo"
                                        />
                                    </div>
                                    <div className="hidden sm:ml-6 sm:block">
                                        <div className="flex space-x-4">
                                            {navigation.map((item) => (
                                                <a
                                                    key={item.name}
                                                    href={item.href}
                                                    className={classNames(
                                                        item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                                        'rounded-md px-3 py-2 text-sm font-medium',
                                                    )}
                                                    aria-current={item.current ? 'page' : undefined}
                                                >
                                                    {item.name}
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                                    <div className='search-cover' sx={{ display: { xs: 'none', sm: 'block' } }}>
                                        <TextField id="search-input"
                                            value={searchText}
                                            type='text'
                                            placeholder="Search products here..."
                                            onChange={handleSearchChange}
                                        />
                                        <ClearIcon
                                            className="clear-icon"
                                            onClick={resetSearchInput}
                                        />
                                        <MagnifyingGlassIcon
                                            className="glass-icon"
                                            onClick={GetSearchResults}
                                        />
                                    </div>

                                    <div className='m-search flex'  >
                                        <input className='m-input' type='text'
                                            placeholder='Search...' onChange={handleSearchChange} />
                                        <MagnifyingGlassIcon
                                            className="m-glass"
                                            onClick={GetSearchResults}
                                        />
                                    </div>
                                    {/* <button className='m-btn'>submit</button> */}
                                    <div onClick={GetCart}>
                                    <div className='flex'>
                                        <ShoppingBagIcon className="cart-icon    bg-gray-800 p-1 text-gray-400 hover:text-white "  />
                                        <span className="cart-count relative cursor-pointer ">{cartCount}</span>
                                    </div>
                                    </div>
                                    {/* Profile dropdown */}
                                       
                                    <Menu as="div" className="relative ml-3">
                                        <div>
                                            <MenuButton className="relative flex rounded-full bg-gray-800 text-sm focus:outline-none  ">
                                                <span className="absolute -inset-1.5" />
                                                <span className="sr-only">Open user menu</span>
                                                <img
                                                    className="h-8 w-8 rounded-full user-prof"
                                                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                                                    alt="profile"
                                                />
                                            <div className='user-name'>Hi { firstName }</div>
                                            </MenuButton>
                                        </div>
                                        
                                        <MenuItems
                                            transition
                                            className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                        >
                                            <MenuItem>
                                                <div
                                                    onClick={GetPortal}
                                                    className={classNames('bg-gray-100 text-sm text-gray-700 profile')}
                                                >
                                                    Your Profile
                                                </div>

                                            </MenuItem>
                                            <MenuItem>
                                                {({ focus }) => (
                                                    <div
                                                        href="#"
                                                        className={classNames('bg-gray-100 text-sm text-gray-700 profile')}
                                                    >
                                                        Settings
                                                    </div>
                                                )}
                                            </MenuItem>
                                            <MenuItem>
                                                {({ focus }) => (
                                                    <div
                                                        href="#"
                                                        className={classNames('bg-gray-100  text-sm text-gray-700 profile')}
                                                    >
                                                        Sign out
                                                    </div>
                                                )}
                                            </MenuItem>
                                        </MenuItems>
                                    </Menu>

                                </div>




                            </div>
                        </div>


                        <DisclosurePanel className="sm:hidden">
                            <div className="space-y-1 px-2 pb-3 pt-2">
                                {navigation.map((item) => (
                                    <DisclosureButton
                                        key={item.name}
                                        as="a"
                                        href={item.href}
                                        className={classNames(
                                            item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                            'block rounded-md px-3 py-2 text-base font-medium',
                                        )}
                                        aria-current={item.current ? 'page' : undefined}
                                    >
                                        {item.name}
                                    </DisclosureButton>
                                ))}
                            </div>
                        </DisclosurePanel>
                        <div className="category">{returnHeaderStyle()}</div>
                    </>
                )}

            </Disclosure>
        </Box>
    )
}
